import type { SrInsightType } from '@plato/data/starrocks/types';
import { brandPreferenceGroupingInsightTypes } from '@plato/insights/context';

export type ProductRecommendationsBrandGroups<T extends { is_preferred_brand: boolean }> =
    | { hasBrandPreference: false; items: T[] }
    | { hasBrandPreference: true; preferred: T[]; other: T[] };

/**
 * Splits an already-ordered recommendation list into a preferred-brand group and an
 * "other" group, preserving each group's relative order. Falls back to no grouping when
 * nothing in the list is brand-preferred, so callers can render today's flat list as-is.
 */
export function groupProductRecommendationsByBrandPreference<T extends { is_preferred_brand: boolean }>(
    items: T[],
): ProductRecommendationsBrandGroups<T> {
    const preferred = items.filter((item) => item.is_preferred_brand);
    if (preferred.length === 0) {
        return { hasBrandPreference: false, items };
    }
    return { hasBrandPreference: true, preferred, other: items.filter((item) => !item.is_preferred_brand) };
}

export function supportsBrandPreferenceGrouping(insightType: SrInsightType): boolean {
    return (brandPreferenceGroupingInsightTypes as readonly string[]).includes(insightType);
}
